const responseCodes = {
  // continue: 100,
  // switchingProtocols: 101,
  ok: 200,
  created: 201,
  accepted: 202,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404
}

export default responseCodes



// WEBPACK FOOTER //
// ./src/services/http-response-codes.js